import { useTranslation } from "react-i18next";
import { SUPPORTED_LANGUAGES } from "../i18n";

/**
 * EN / FR pill toggle. Persists the choice via i18next-browser-languagedetector
 * (localStorage key "e1x-lang", wired in src/i18n/index.js), so it survives
 * reloads and future visits.
 */
export default function LanguageSwitcher({ className = "" }) {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

  return (
    <div
      className={`inline-flex items-center gap-0.5 border border-gray-200 rounded-full p-0.5 ${className}`}
      role="group"
      aria-label="Language"
    >
      {SUPPORTED_LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => i18n.changeLanguage(lang.code)}
          aria-pressed={current === lang.code}
          className={`px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider transition-colors cursor-pointer ${
            current === lang.code
              ? "bg-primary text-white"
              : "text-gray-400 hover:text-[#0b0f19]"
          }`}
        >
          {lang.shortLabel}
        </button>
      ))}
    </div>
  );
}
